import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SearchDocumentsService } from '../service/search.service';
import * as SearchDocumentsActions from './search.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { TrackingService } from '@schueco/angular-tracking';

@Injectable()
export class SearchDocumentsEffects {
  private actions$ = inject(Actions);
  private searchDocumentsService = inject(SearchDocumentsService);
  private trackingService = inject(TrackingService);

  getDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchDocumentsActions.searchDocuments),
      switchMap((action) => {
        this.trackingService.trackSearch(action.searchTerm || '');

        return this.searchDocumentsService
          .searchDocuments(
            action.categoryId,
            action.language,
            action.filterIds,
            action.searchTerm,
            action.limit,
            action.page,
            action.searchType,
            action.sort,
          )
          .pipe(
            map((_response) => {
              return SearchDocumentsActions.loadDocumentsSuccess({ data: _response });
            }),
            catchError((error) => {
              return of(SearchDocumentsActions.loadDocumentsFailure({ error }));
            }),
          );
      }),
    ),
  );
}
